import React from 'react';
import { useTranslation } from 'react-i18next';
import { User } from 'graphql-common';
import CircleLoader from '@lib/components/CircleLoader/CircleLoader';
import ErrorPage from '@lib/components/ErrorPage/ErrorPage';
import getStatusFromError from '@lib/utils/getStatusFromError';
import getDescriptionFromError from '@lib/utils/getDescriptionFromError';
import getDefaultValuesFromQueryData from 'routes/Users/utils/getDefaultValuesFromQueryData';
import useActions from './utils/useActions';
import UserForm from './UserForm';

interface Props {
  isOpen: boolean;
  onCancel: () => void;
  onSubmitCallback: (v?: User | null) => void;
  selectedUserId?: string | null;
}

function UserFormContainer(props: Props) {
  const { isOpen, onCancel, onSubmitCallback, selectedUserId } = props;
  const { t } = useTranslation();

  const {
    countriesCodes,
    countriesError,
    graphQLErrors,
    loading,
    onSubmitUserForm,
    sectorsLoadOptions,
    selectedUser,
    sitesLoadOptions,
    teamsLoadOptions,
    userError,
    userLoading,
  } = useActions({
    selectedUserId,
    isOpen,
    onSubmitCallback,
  });

  if (userLoading) {
    return <CircleLoader />;
  }

  if (userError) {
    return (
      <ErrorPage
        status={getStatusFromError(userError)}
        description={getDescriptionFromError(userError)}
      />
    );
  }

  if (countriesError) {
    return (
      <ErrorPage
        status={getStatusFromError(countriesError)}
        description={getDescriptionFromError(countriesError)}
      />
    );
  }

  const defaultValues = getDefaultValuesFromQueryData(t, {
    ...selectedUser,
  });

  return (
    <UserForm
      countriesCodes={countriesCodes}
      defaultValues={defaultValues}
      graphQLErrors={graphQLErrors}
      loading={loading}
      onCancel={onCancel}
      onSubmit={onSubmitUserForm}
      sectorsLoadOptions={sectorsLoadOptions}
      sitesLoadOptions={sitesLoadOptions}
      teamsLoadOptions={teamsLoadOptions}
    />
  );
}

export default UserFormContainer;
